<template>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1177.4 279.2"
        style="enable-background: new 0 0 1177.4 279.2"
        xml:space="preserve"
        :id="id"
    >
        <svg:style type="text/css">
            #{{ id }} > .b7-st0 {
                 fill: {{ color }};
             }
            #{{ id }} > .b7-st1 {
                 fill: #ffffff;
             }
        </svg:style>
        <path
            class="b7-st0"
            d="M80.2,0h1017c44.3,0,80.2,35.9,80.2,80.2v118.9c0,44.3-35.9,80.2-80.2,80.2H80.2C35.9,279.2,0,243.3,0,199.1
	V80.2C0,35.9,35.9,0,80.2,0z"
        />
        <path
            class="b7-st1"
            d="M186,35.6c-60,0-108.6,39.6-108.6,88.4c0,22.7,10.5,43.4,27.8,59c-4.7,39.6,22.4,64.2,22.4,64.2
	c-3.2-14,9.3-28.9,22-39.9c11.9,3.4,24.1,5.1,36.5,5.1c60,0,108.6-39.6,108.6-88.4S246,35.6,186,35.6z"
        />
        <path
            class="b7-st1"
            d="M338,179c0-19.4-14.3-36.2-35.2-44.6c-2.6,37.8-34.5,69.3-77.5,79.7c11.9,9.4,28.6,15.3,47.1,15.3
	c7.4,0,14.8-1,22-2.9c7.7,6.3,15.2,14.8,13.3,22.7c0,0,16.4-14,13.5-36.5C331.6,203.7,338,191.9,338,179z"
        />
    </svg>
</template>

<script>
export default {
    name: "Bubble7",
    data() {
        return {
            id: "b7" + Math.ceil(Math.random() * 1000),
        };
    },
    props: {
        color: {
            type: String,
            default: "#2b2b2b",
        },
    },
};
</script>
